import React, { useEffect, useState } from "react";
import { Mail, Phone, Trash2, Check, MessageSquare } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminContact() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/contact").then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.put(`/admin/contact/${id}/read`); load(); };
  const remove = async (id) => {
    if (!window.confirm("Mesajı silmek istediğinize emin misiniz?")) return;
    await api.delete(`/admin/contact/${id}`);
    load();
  };

  return (
    <div>
      <span className="section-eyebrow">Yönetim</span>
      <h1 className="font-display text-4xl mt-2 mb-8">İletişim Mesajları</h1>

      <div className="space-y-4">
        {items.map(m => (
          <div key={m.id} className={`bg-surface border p-6 ${m.read ? "border-white/5" : "border-gold-30"}`}>
            <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
              <div>
                <div className="font-display text-xl flex items-center gap-2">
                  {m.name}
                  {!m.read && <span className="text-[10px] uppercase tracking-widest text-gold border border-gold-30 px-2 py-0.5">Yeni</span>}
                </div>
                <div className="text-xs text-white/50 mt-1">{new Date(m.created_at).toLocaleString("tr-TR")}</div>
              </div>
              <div className="flex items-center gap-2">
                {!m.read && <button onClick={() => markRead(m.id)} className="text-white/60 hover:text-gold p-2" title="Okundu"><Check className="w-4 h-4" /></button>}
                <button onClick={() => remove(m.id)} className="text-white/60 hover:text-red-400 p-2"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <div className="flex flex-wrap gap-4 text-sm text-white/70 mb-4">
              <a href={`mailto:${m.email}`} className="flex items-center gap-2 hover:text-gold"><Mail className="w-3.5 h-3.5" /> {m.email}</a>
              {m.phone && <a href={`tel:${m.phone}`} className="flex items-center gap-2 hover:text-gold"><Phone className="w-3.5 h-3.5" /> {m.phone}</a>}
              {m.subject && <span className="flex items-center gap-2"><MessageSquare className="w-3.5 h-3.5" /> {m.subject}</span>}
            </div>
            <div className="hairline mb-4" />
            <p className="text-white/85 whitespace-pre-line">{m.message}</p>
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-white/50 py-16">Henüz mesaj yok.</div>}
      </div>
    </div>
  );
}
